import { defineComponent as _defineComponent } from 'vue'
import Info from '@/components/DynamicInfo.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { formatarPublicacoes } from '@/utils/util';
import { useVuetify } from '@/composables/useVuetify';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposProducaoCientifica',
  setup(__props) {

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);

return { __sfc: true,vuetify, store, obra, Info, TabelaLocalizacao, formatarPublicacoes }
}

})